// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-item[data-v-07059e1c] ::-webkit-scrollbar{-webkit-appearance:none;width:10px}.search-item[data-v-07059e1c] ::-webkit-scrollbar-thumb{border-radius:5px;background-color:rgba(0,0,0,.5);-webkit-box-shadow:0 0 1px hsla(0,0%,100%,.5)}.no-opt[data-v-07059e1c]{padding:0 5px}.footerloader[data-v-07059e1c]{padding:3px 20px;font-style:italic}.search-item .vs__dropdown-option b[data-v-07059e1c]{word-wrap:break-word;white-space:normal}", ""]);
// Exports
module.exports = exports;
